import React, { FC, memo, useCallback } from "react";
import { useDispatch } from "react-redux";
import { addNotification } from "@actions/notifications.actions";
import MenuExamplesPopup from "@containers/MenuExamplesPopup";
import { useMenuExamplesPopupData } from "@apiHooks/useMenuExamplesPopupData";

interface ByoMenuExamplePopupProps {
    fetch: (options: any) => Promise<any>;
    isShown: boolean;
    close: () => void;
    fetchExport?: (options: any) => Promise<string | void>;
    downloadUrl?: string;
}

const ByoMenuExamplePopup: FC<ByoMenuExamplePopupProps> = ({
    fetch,
    isShown,
    close,
    fetchExport,
    downloadUrl,
}) => {
    const dispatch = useDispatch();

    const handleAddNotification = useCallback(
        (notification: unknown) => dispatch(addNotification(notification)),
        [dispatch]
    );

    const {
        download,
        tableData,
        sort,
        getMenuExamples,
        totalCountExamples,
        isLoading,
        handleSortColumn,
        searchQuery,
        handleChangeSearchQuery,
    } = useMenuExamplesPopupData({
        fetch,
        addNotification: handleAddNotification,
        isShown,
        fetchExport,
        downloadUrl,
    });

    return (
        <MenuExamplesPopup
            isShown={isShown}
            close={close}
            download={download}
            tableData={tableData}
            isLoading={isLoading}
            totalCountExamples={totalCountExamples}
            getMenuExamples={getMenuExamples}
            sort={sort}
            handleSortColumn={handleSortColumn}
            searchQuery={searchQuery}
            handleChangeSearchQuery={handleChangeSearchQuery}
        />
    );
};

export default memo(ByoMenuExamplePopup);
